import { render, staticRenderFns } from "./bankruptcyManagerInfo.vue?vue&type=template&id=4353981b&scoped=true&"
import script from "./bankruptcyManagerInfo.vue?vue&type=script&lang=js&"
export * from "./bankruptcyManagerInfo.vue?vue&type=script&lang=js&"
import style0 from "./bankruptcyManagerInfo.vue?vue&type=style&index=0&id=4353981b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4353981b",
  null
  
)

export default component.exports